<template>
  <div class="mc-datatable__empty">
    <!-- @slot Use this slot to insert an error message if the component is empty. An empty state is defined if there are no data/results. -->
    <slot />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({ name: 'MDataTableEmpty' });
</script>

<style lang="scss">
@import 'settings-tools/all-settings';
@import 'components/c.datatable-empty';
</style>
